import { RecHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetProgramLevelInstanceData = (programLevelInstanceId, state, setState) => {
  if (state.isObjLoading !== true && programLevelInstanceId > 0 && !state.message) {
    let newState = {
      ...state,
      programLevelInstanceId,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const programLevelInstanceIdForUrl = programLevelInstanceId ? encodeURIComponent(programLevelInstanceId) : 'NaN';
    const url = `/ProgramLevel/ProgramLevelInstance/${programLevelInstanceIdForUrl}`;
    RecHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  };
};

export default GetProgramLevelInstanceData;